/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import ScrollToTop from '../../Components/scrollup'
import ScrollPage from "../../Components/scrollpageUp";
import FacebookIcon from "../../Images/contactIcon/fb.png";
import InstagramIcon from "../../Images/contactIcon/insta.png";
import YouTubeIcon from '../../Images/contactIcon/youtube.png';
import "./style.css";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { useInView } from "framer-motion";
import { useRef } from "react";
import Footer from "../../Components/Footer";
import phone from "../../Images/contactIcon/phone.png"
import mail from "../../Images/contactIcon/mail.png"
import local from "../../Images/contactIcon/local.png"
export default function Contacts() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#000",
        dark: "#222",
        contrastText: "#FFCD00",
      },
    },
  });
  const ref2 = useRef(null);
  const isInView2 = useInView(ref2, { once: true });
  return (
    <ThemeProvider theme={theme}>
      <div className="info">
      <ScrollToTop/>
      <ScrollPage/>
      <div className="contactBack">
        <div>
        <p>Vous avez une question sur nos produits, un conseil pour votre projet ? <br/>
Vous souhaitez Demander un Devis Gratuit ? 
</p>
<h1>contactez-nous</h1>
</div>
          </div>
     
        <div>
          <div
            className="infoDetails"
            ref={ref2}
            style={{
              transform: isInView2 ? "none" : "translateX(200px)",
              opacity: isInView2 ? 1 : 0,
              transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
            }}
          >
            <div>
              <div>
              <img src={local} alt="local" />
            <a href="#" className="contact-link">
                Route l'afrane km 6, Sfax, Tunisia, 3093
              </a>
              </div>
              <div>
              <img src={phone} alt="phone" />
              <a href="tel:+21658421628" className="footer-link">
                {" "}
                58 421 628
              </a>
              </div>
               <div>
              <img src={phone} alt="phone" />
              <a href="tel:+21658421621" className="footer-link">
                {" "}
                58 421 621
              </a>
              </div>
              <div>
              <img src={mail} alt="mail" />
              <a
                href="mailto:ellouzealumarketing@gmail.com"
                className="contact-link"
              >
               ellouzealumarketing@gmail.com
              </a>
              </div>
              <div>
        
              <div>
                <h4> suivez-nous :</h4>
              <a href="https://www.facebook.com/ellouzealu.tn/" target="_blank" rel="noreferrer">
         <img src={FacebookIcon} alt="facebookIcon" />
         </a>
         <a href="https://www.instagram.com/ellouze_alu" target="_blank" rel="noreferrer">
         <img src={InstagramIcon} alt="instagramIcon" /></a>
         <a href="https://www.youtube.com/@EllouzeAlu" target="_blank" rel="noreferrer">
         <img src={YouTubeIcon} alt="youtubeIcon" /></a>
              </div>
              </div>
            </div>
            
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.0409100029797!2d10.703925688854978!3d34.779745399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301d5d41e806a8b%3A0xa7c5e823dd0eae06!2sEllouze%20menuiserie%20aluminium!5e0!3m2!1sfr!2stn!4v1746262929185!5m2!1sfr!2stn"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              className="infoMap"
            ></iframe>
          </div>
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  );
}
